// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "js/" + chunkId + "." + {"354":"955eae98","480":"c93f6f53","838":"5113efe9"}[chunkId] + ".js";
};